import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { HomePage } from '../home/home';


/**
 * Generated class for the InterestratecertificatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-interestratecertificate',
  templateUrl: 'interestratecertificate.html',
})
export class InterestratecertificatePage {

  arrReason:any=[];
  communicationEmail:any="";
   
  errorDisplay:any={};
  listCategotyComplains:any=[];
  listSubCategotyComplains:any=[];
  category:any="";
  subcomplain:any="";
  ccs_remarks:any="";
  reason:any="";
  contactDtailsData:any;
  constructor(
    private loadingCtrl:LoadingController,

    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ForseclousrestatementsPage');
    this.contactDtailsData = this.navParams.data.addressDetail.responseParameters.filter((res:any)=>{
      return res.mailingaddress=="Y" && res.addresstype== "CURRES" && res.applicanttype=='Applicant'
    })[0];
    this.communicationEmail = this.contactDtailsData.emailid
    this.getForeclousreCategoryDetails();
    this.reason="";
  }
getForeclousreCategoryDetails(){
    
    let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    this.cp.getFinancialYear(loading).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            this.arrReason = res
                           })
    
  }
  presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
             this.navCtrl.setRoot(HomePage);
          }
        }
      ]
    });
    actionSheet.present();
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
    //console.log(this.errorDisplay,document.forms[0])
    //return false
    if(this.errorDisplay.valid){
     return false;
   }
   else if(this.reason==""){
        this.errorDisplay.reason="Please select financial year";
        //console.log(this.errorDisplay)
        return false
   }else{
    var ccs_casecategory="CC02";;
    var ccs_casetype="CT22";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST109";
    var ccs_remarks = this.ccs_remarks;
    console.log(this.reason);
 

  let loading = this.loadingCtrl.create({
    content: 'Please wait...'
  });
  loading.present();
    this.cp.postInterestCertificates(loading,ccs_casecategory,ccs_remarks,
                           JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,ccs_casetype,
                           ibhfl_loanaccountnumber1,
                           ccs_originatingsource,
                           ccs_casesubtype,this.reason).then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            this.presentActionSheet("Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
   
   }
   }

}



// WEBPACK FOOTER //
// ./src/pages/interestratecertificate/interestratecertificate.ts